import CluodCertModalActionTypes from './cloud-cert-modal.types'

const INITIAL_STATE = {
  open: false
}

const cloudCertModalReducer = (state=INITIAL_STATE, action) => {
  switch(action.type) {
    case CluodCertModalActionTypes.SHOW_MODAL:
      return {
        ...state,
        open: true
      }
    case CluodCertModalActionTypes.HIDE_MODAL:
      return {
        ...state,
        open: false
      }
    default:
      return state;
  }
} 

export default cloudCertModalReducer